export const Brands = {
  Wireless: 'wls',
  TheSun: 'ngn',
  TheTimes: 'tnl',
  TheTimesCom: 'tnl_com',
  Tls: 'tls',
  TlsCom: 'tls_com'
};

export const MyAccountUrls = {
  prod: 'https://myaccount.wireless.radio',
  staging: 'https://myaccount.staging.wireless.radio',
  development: 'https://myaccount.dev.wireless.radio'
};

export const MY_ACCOUNT_BRAND_QUERY_PARAM = 'brand';
